import { Controller } from "@hotwired/stimulus"

import {stimulus} from "../init"

// Reusable slide-over panel. Needs a `panel` target; `scrim` is optional.
// Mark the field to focus on open with data-autofocus.
export default class SlideOver extends Controller {
  static targets = ["panel", "scrim"]
  static values = { open: Boolean }

  connect() {
    this.sync()
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  keydown(event) {
    if (event.key === "Escape" && this.openValue) this.close()
  }

  openValueChanged() {
    this.sync()
  }

  sync() {
    if (!this.hasPanelTarget) return
    const open = this.openValue

    this.panelTarget.dataset.open = String(open)
    this.panelTarget.inert = !open
    if (this.hasScrimTarget) this.scrimTarget.dataset.open = String(open)
    document.body.classList.toggle("overflow-hidden", open)
    if (open) this.panelTarget.querySelector("[data-autofocus]")?.focus()
  }
}

stimulus.register('slide-over', SlideOver)
